const cleanObject = (obj: Record<string, any>) => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== null &&
        value !== undefined &&
        value !== '' &&
        value !== false &&
        !(Array.isArray(value) && value.length === 0)
    )
  );
};

export const parseFiltersToParams = (filters: Record<string, any>) => {
  const cleanFilters = cleanObject(filters);
  const params = new URLSearchParams();

  // Agregar múltiples valores para la misma clave
  cleanFilters.bus_type_id?.forEach((id) => {
    params.append('bus_type_id[]', String(id));
  });

  if (cleanFilters.bus_type_id?.length) {
    delete cleanFilters.bus_type_id;
  }

  Object.entries(cleanFilters).forEach(([key, value]) => {
    params.append(key, String(value));
  });

  return params.toString();
};
